import { Outlet, Link } from 'react-router-dom';
import { Moon, Sun } from 'lucide-react';
import { appConfig } from '@/config';
import { ROUTES } from '@/constants';
import { BrandLogo } from '@/components/common';
import { BrandSubtitle } from '@/components/common/Brand.styles';
import { Button } from '@/components/ui';
import { useTheme } from '@/context/ThemeContext';

export function AuthLayout() {
  const { theme, toggleTheme } = useTheme();

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-[var(--background)] px-4 py-10">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_90%_55%_at_50%_-15%,_rgb(8_145_178_/_0.16),_transparent_55%),radial-gradient(ellipse_55%_40%_at_100%_20%,_rgb(59_130_246_/_0.1),_transparent_50%),radial-gradient(ellipse_50%_40%_at_0%_80%,_rgb(124_92_255_/_0.08),_transparent_45%),linear-gradient(165deg,_#f8fafc_0%,_#eef2ff_42%,_#e2e8f0_100%)] dark:bg-[radial-gradient(ellipse_80%_50%_at_50%_-10%,_rgb(34_211_238_/_0.2),_transparent_50%),radial-gradient(ellipse_60%_40%_at_80%_100%,_rgb(124_92_255_/_0.16),_transparent_50%),radial-gradient(ellipse_50%_35%_at_10%_90%,_rgb(59_130_246_/_0.12),_transparent_45%),linear-gradient(180deg,_#020617,_#070b14)]"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-[0.35] dark:hidden"
        style={{
          backgroundImage:
            'linear-gradient(rgb(148 163 184 / 0.12) 1px, transparent 1px), linear-gradient(90deg, rgb(148 163 184 / 0.12) 1px, transparent 1px)',
          backgroundSize: '48px 48px',
          maskImage: 'radial-gradient(ellipse 70% 60% at 50% 40%, black, transparent)',
        }}
      />

      <Button
        type="button"
        variant="ghost"
        size="icon"
        onClick={toggleTheme}
        aria-label={theme === 'dark' ? 'Ativar tema claro' : 'Ativar tema escuro'}
        className="absolute top-4 right-4 z-20 border border-[var(--border)] bg-[var(--card)]/80 text-[var(--muted-foreground)] shadow-[var(--shadow-sm)] backdrop-blur-sm hover:text-[var(--foreground)]"
      >
        {theme === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
      </Button>

      <div className="relative z-10 w-full max-w-[26rem] animate-[auth-enter_480ms_ease-out]">
        <div className="mb-7 flex flex-col items-center text-center">
          <Link
            to={ROUTES.HOME}
            aria-label={appConfig.appName}
            className="inline-flex outline-none transition-transform duration-300 hover:scale-[1.02] focus-visible:ring-2 focus-visible:ring-[var(--brand-cyan)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--background)]"
          >
            <BrandLogo
              variant="mark"
              size={null}
              className="h-auto mix-blend-screen dark:mix-blend-normal"
              style={{ width: '4.5rem' }}
            />
          </Link>
          <div className="mt-5 max-w-[22rem]">
            <BrandSubtitle>{appConfig.tagline}</BrandSubtitle>
          </div>
        </div>

        <div className="auth-form-shell [&>div]:rounded-2xl [&>div]:border [&>div]:border-slate-200/90 [&>div]:bg-white/90 [&>div]:p-6 [&>div]:shadow-[0_24px_60px_-28px_rgba(15,23,42,0.28),0_8px_20px_-12px_rgba(8,145,178,0.18)] [&>div]:backdrop-blur-md sm:[&>div]:p-7 dark:[&>div]:border-[var(--border)] dark:[&>div]:bg-[var(--card)] dark:[&>div]:shadow-[var(--shadow)] dark:[&>div]:backdrop-blur-none [&_input]:border-[var(--input-border)] [&_input]:bg-slate-50 dark:[&_input]:bg-[var(--card)]">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
